import React from "react";

/**
 * Harita renderer hatalarini sayfanin geri kalanindan izole eder.
 * Hata detayi loglanmaz; konum, token veya kullanici verisi sizmaz.
 */
export default class HaritaErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    try { this.props.onError?.(); } catch (_) {}
  }

  componentDidUpdate(previousProps) {
    if (this.state.hasError && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) return this.props.fallback || null;
    return this.props.children;
  }
}
